import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import DisenrollmentReportActions, { DisenrollmentReportRedux, DisenrollmentReportTypes } from '../Redux/DisenrollmentReportRedux'
import { notificationFail } from '../Redux/NotificationActions'

const DisenrollmentReportCRUDObservable = createCRUDObservable({
  mainRedux: DisenrollmentReportRedux,
  reduxPath: 'disenrollmentreport',
})

const disenrollmentsEpic = (action$, store, { Api }) =>
  action$.ofType(DisenrollmentReportTypes.DisenrollmentReportRequest)
    .mergeMap(({ start_date, end_date }) => (
      Observable
        .fromPromise(Api.disenrollmentreport.getDisenrollmentReportExcel(start_date, end_date)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              DisenrollmentReportActions.DisenrollmentReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            DisenrollmentReportActions.DisenrollmentReportSuccess(data, fileName),
          ]
        })
    ))

const centersDisenrollmentsEpic = (action$, store, { Api }) =>
  action$.ofType(DisenrollmentReportTypes.CentersDisenrollmentReportRequest)
    .mergeMap(({ start_date, end_date, centerId }) => (
      Observable
        .fromPromise(Api.disenrollmentreport.getCentersDisenrollmentReportExcel(start_date, end_date, centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              DisenrollmentReportActions.CentersDisenrollmentReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            DisenrollmentReportActions.CentersDisenrollmentReportSuccess(data, fileName),
          ]
        })
    ))

export const DisenrollmentReportObservers = Object.assign({}, DisenrollmentReportCRUDObservable.observers, {})
export const disenrollmentreportEpic = combineEpics(
  DisenrollmentReportCRUDObservable.epic,
  disenrollmentsEpic,
  centersDisenrollmentsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/DisenrollmentReportObservable.js